import { SelectListWrapper } from 'components/ui/SelectList/SelectListStyles';
import styled from 'styled-components';
import { reviewLine } from 'styles/Colors';

export const NoteCellWrapper = styled.div`
  display: flex;
  overflow: hidden;
  width: 100%;

  ${SelectListWrapper} {
    padding: 0;
    position: absolute;
    z-index: 100;
    right: 0;
    top: 50px;
    width: 187px;
    font-family: Lato;
    font-size: 15px;
  }
`;

export const Control = styled.div`
  height: 60px;
  display: flex;
  align-items: center;

  label {
    margin: 0 14px;
  }
`;

export const Text = styled.div`
  word-break: break-word;
  padding: 20px 12px 17px 12px;
  border-bottom: 1px solid ${reviewLine};
`;

export const Note = styled.div`
  margin-left: 9px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

export const ExpandIconWrapper = styled.div`
  margin-left: auto;
  transition: all 0.3s;

  &.expanded {
    transform: rotate(180deg);
  }

  svg {
    cursor: pointer;
  }
`;
